import detector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './locales';

i18n.use(detector).use(initReactI18next).init({
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false
    },
    keySeparator: false,
    nsSeparator: false,
    pluralSeparator: false,
    resources
});

i18n.getLanguage = () => 'es';

i18n.toggleLanguage = () => null;

i18n.load = () => null;

export default i18n;
